import React, { ReactNode, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSettledFeatureFlag } from "shared-ui/src/hooks/useSettledFeatureFlag";
import LoadingOrError from "shared-ui/src/global-layout/LoadingOrError";

type DevOpsPostureReviewRouteGuardProps = {
  children: ReactNode;
};

const DevOpsPostureReviewRouteGuard = ({
  children,
}: DevOpsPostureReviewRouteGuardProps) => {
  const navigate = useNavigate();
  const { prefix } = useParams<{ prefix?: string }>();
  const { enabled: doprEnabled, isLoading } = useSettledFeatureFlag(
    "spu.enable-devops-posture-review-assessments",
  );

  useEffect(() => {
    if (!isLoading && !doprEnabled) {
      navigate(prefix ? `/${prefix}/assessments` : "/assessments", { replace: true });
    }
  }, [doprEnabled, isLoading, navigate, prefix]);

  if (isLoading) return <LoadingOrError loading />;
  if (!doprEnabled) return null;

  return <>{children}</>;
};

export default DevOpsPostureReviewRouteGuard;